import React from "react";
import { cn } from "@/lib/utils";

const MILESTONES = [10, 20, 30];

export default function ProgressBar({ value = 0, target = 30, showMilestones = true, className }) {
  const pct = Math.min((value / target) * 100, 100);
  return (
    <div className={cn("w-full", className)}>
      <div className="relative w-full bg-[#1F2937] rounded-full h-2.5 overflow-visible">
        <div
          className="absolute left-0 top-0 h-2.5 rounded-full bg-gradient-to-r from-blue-500 via-blue-400 to-orange-500 transition-all duration-700"
          style={{ width: `${pct}%` }}
        />
        {showMilestones &&
          MILESTONES.map((m) => {
            const pos = (m / target) * 100;
            const reached = value >= m;
            return (
              <div
                key={m}
                className="absolute -top-1 -translate-x-1/2"
                style={{ left: `${pos}%` }}
              >
                <div
                  className={cn(
                    "w-1 h-4 rounded-sm",
                    reached ? "bg-orange-400" : "bg-white/30",
                  )}
                />
              </div>
            );
          })}
      </div>
      {showMilestones && (
        <div className="flex justify-between mt-1.5 text-[10px] font-mono text-gray-500">
          {MILESTONES.map((m) => (
            <span key={m} className={value >= m ? "text-orange-400" : ""}>
              {m}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
